/*
  Nice Candy: Wolken im Hero-Knopf am Desktop (9.10.2026).
  Fährt die Maus über "Jetzt entdecken" (oder springt die Tastatur darauf), wird der Knopf zu einem Stück Himmel
  wie im Logo: hellblau, weiße Schrift, zwei Logo-Wolken schweben sanft ein (oben rechts und unten links).
  Beim Wegfahren oder Klicken ziehen die Wolken in ihrer Flugrichtung weiter und lösen sich auf.
  Nur auf Geräten mit Maus ab 750 px Breite. Am Handy beim 1., 4., 7. ... Erscheinen ein Wolken-Gruß (Folie 1) bzw. Squish mit Glitzer (Squishy-Folie).
  Gestaltung in assets/nice-candy.css ("Hero Desktop: Logo-Knopf" und "Hero Handy: Wolken-Gruß").
  Außerdem: automatischer Folienwechsel pausiert beim Festhalten (calmAutoplay).
*/
(function () {
  var mq = window.matchMedia('(hover: hover) and (min-width: 750px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ease = 'cubic-bezier(.22,.61,.36,1)';
  var cloud =
    '<svg viewBox="0 0 120 60" aria-hidden="true" focusable="false">' +
    '<path d="M14 52 C2 52 2 36 14 35 C12 22 28 18 36 26 C40 10 62 8 68 22 C76 12 96 16 94 32 C108 30 114 50 100 52 Z" fill="#fff" stroke="#e3f3fb" stroke-width="2"/>' +
    '<path d="M18 50 C30 46 50 47 60 49 C74 46 90 46 100 50 C92 54 30 55 18 50 Z" fill="#d9eef9"/></svg>';

  var heart =
    '<svg viewBox="0 0 24 22" aria-hidden="true" focusable="false">' +
    '<path d="M12 21.2C11.6 21.2 1 14.6 1 7.4 1 4 3.6 1.4 6.8 1.4c2.1 0 3.9 1.1 5.2 2.9 1.3-1.8 3.1-2.9 5.2-2.9C20.4 1.4 23 4 23 7.4c0 7.2-10.6 13.8-11 13.8z" fill="#ff2e55"/>' +
    '<path d="M6.2 4.6c-1.6.4-2.6 1.8-2.6 3.3" stroke="#fff" stroke-width="1.6" stroke-linecap="round" fill="none" opacity=".7"/></svg>';

  function move(el, transform, opacity, dur, delay) {
    if (still.matches) dur = 0;
    el.style.transition = dur
      ? 'transform ' + dur + 's ' + ease + ' ' + (delay || 0) + 's, opacity ' + dur * 0.6 + 's ease ' + (delay || 0) + 's'
      : 'none';
    el.style.transform = transform;
    el.style.opacity = opacity;
  }

  function setup(btn) {
    if (btn.dataset.ncClouds) return;
    btn.dataset.ncClouds = '1';
    // Text in ein eigenes Element, damit er immer über den Wolken liegt
    var tx = document.createElement('span');
    tx.className = 'nc-cl-tx';
    while (btn.firstChild) tx.appendChild(btn.firstChild);
    var a = document.createElement('span');
    var b = document.createElement('span');
    // Squishy-Folie: zwei rote Herzen statt Wolken (Knopf wird dort hellrosa statt hellblau, siehe nice-candy.css)
    var shape = btn.closest('[id$="slide_suesses"]') ? heart : cloud;
    a.className = 'nc-cloud nc-cloud--a' + (shape === heart ? ' nc-heart' : '');
    b.className = 'nc-cloud nc-cloud--b' + (shape === heart ? ' nc-heart' : '');
    a.innerHTML = shape;
    b.innerHTML = shape;
    btn.appendChild(a);
    btn.appendChild(b);
    btn.appendChild(tx);

    var on = false;
    function enter() {
      if (!mq.matches || on) return;
      on = true;
      btn.classList.add('nc-sky');
      move(a, 'translate(90px,-14px) rotate(6deg) scale(.7)', 0);
      move(b, 'translate(-100px,14px) rotate(-6deg) scale(.7)', 0);
      void btn.offsetWidth;
      move(a, 'none', 1, 0.9, 0);
      move(b, 'none', 1, 1, 0.08);
    }
    function leave() {
      if (!on) return;
      on = false;
      btn.classList.remove('nc-sky');
      move(a, 'translate(-80px,-10px) rotate(-4deg) scale(.85)', 0, 0.9, 0);
      move(b, 'translate(90px,10px) rotate(4deg) scale(.85)', 0, 1, 0.05);
    }
    btn.addEventListener('mouseenter', enter);
    btn.addEventListener('mouseleave', leave);
    btn.addEventListener('focus', function () { if (btn.matches(':focus-visible')) enter(); });
    btn.addEventListener('blur', leave);
    btn.addEventListener('click', leave);
  }

  // Handy: Animationen der Hero-Knöpfe beim 1., 4., 7. ... Erscheinen der Folie (Zähler gilt für den ganzen Besuch).
  // Folie 1: Wolken ziehen durch den magenta Knopf. Folie Squishies: Knopf wird gequetscht, gelbe Glitzersternchen.
  function every3(btn, key, cls, delay) {
    var visible = false;
    var io = new IntersectionObserver(function (entries) {
      var now = entries[0].isIntersecting;
      if (now && !visible) {
        var n = 0;
        try { n = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (e) {}
        n += 1;
        try { sessionStorage.setItem(key, String(n)); } catch (e) {}
        if (n % 3 === 1) {
          btn.classList.remove(cls);
          void btn.offsetWidth;
          setTimeout(function () { btn.classList.add(cls); }, delay);
        }
      }
      visible = now;
    }, { threshold: 0.9 });
    io.observe(btn);
  }

  function greet() {
    if (mq.matches || still.matches || !('IntersectionObserver' in window)) return;
    var btn = document.querySelector('[id$="__nc_hero"] .slideshow__slide[id$="slide_squishies"] a.button');
    if (btn) every3(btn, 'ncHeroGreetCount', 'nc-greet', 500);
  }

  var sparks = [[-70, -26, 20, 30], [-50, 22, 24, 60], [60, -30, 78, 30], [72, 18, 74, 60], [-6, -36, 50, 20], [10, 34, 52, 80], [-90, 0, 10, 48], [92, -4, 90, 48]];
  function squish() {
    if (mq.matches || still.matches || !('IntersectionObserver' in window)) return;
    var btn = document.querySelector('[id$="__nc_hero"] .slideshow__slide[id$="slide_suesses"] a.button');
    if (!btn) return;
    sparks.forEach(function (s) {
      var i = document.createElement('i');
      i.className = 'nc-spark';
      i.setAttribute('aria-hidden', 'true');
      i.style.cssText = '--x:' + s[0] + 'px;--y:' + s[1] + 'px;left:' + s[2] + '%;top:' + s[3] + '%';
      btn.appendChild(i);
    });
    every3(btn, 'ncHeroSquishCount', 'nc-squish', 350);
  }

  // Automatischer Folienwechsel (14.10.2026): steht still, solange ein Finger auf dem Hero liegt,
  // und zählt nach dem Loslassen oder einem eigenen Wischer wieder volle 5 Sekunden.
  // Debutifys dbtfy-slider.js wechselt sonst stur im Takt, auch während man festhält.
  function calmAutoplay() {
    var c = document.querySelector('[id$="__nc_hero"] dbtfy-slider-component');
    if (!c || !c.slider || typeof c.play !== 'function' || c.ncCalm) return;
    c.ncCalm = true;
    var holding = false;
    var idle = null;
    var play = c.play.bind(c);
    // Auch Debutify selbst startet den Takt neu (z. B. wenn am Handy die Adressleiste ein- und ausfährt), nie während man festhält
    c.play = function () { if (!holding) play(); };
    function stop() { clearInterval(c.autoplay); clearTimeout(idle); }
    function restart() {
      clearTimeout(idle);
      idle = setTimeout(function () { if (!holding && c.autoPlay && c.totalPages > 1) play(); }, 150);
    }
    c.slider.addEventListener('touchstart', function () { holding = true; stop(); }, { passive: true });
    c.slider.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') { holding = true; stop(); } });
    ['touchend', 'touchcancel', 'pointerup', 'pointercancel'].forEach(function (type) {
      window.addEventListener(type, function () { if (holding) { holding = false; restart(); } }, { passive: true });
    });
    // Nach jeder Bewegung (eigener Wischer oder automatischer Wechsel) beginnt der 5-Sekunden-Takt von vorn
    c.slider.addEventListener('scroll', function () { if (!holding) { clearInterval(c.autoplay); restart(); } }, { passive: true });
  }

  function init() {
    document.querySelectorAll('[id$="__nc_hero"] .slideshow__text a.button').forEach(setup);
    greet();
    squish();
    calmAutoplay();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
